import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-loader-carouse-text',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './loader-carouse-text.component.html',
  styleUrls: ['./loader-carouse-text.component.scss'],
})
export class LoaderCarouseTextComponent {

}
